import React from "react";
import { useTranslation } from "react-i18next";
import { FileText } from "lucide-react";

const colorMap = {
  bgGreen: "#48E56F",
  bgYellow: "#C6E548",
  bgRed: "#E54848",
};

const truncateLink = (link) => {
  if (!link) return "";
  const cleaned = link.replace(/^https?:\/\//i, "");
  return cleaned.length > 40 ? `${cleaned.slice(0, 37)}...` : cleaned;
};

const ClientCard = ({ 
  client, 
  time, 
  status, 
  statusColor, 
  textColor,
  onUserClick 
}) => {
  const { t } = useTranslation();
  
  const borderColor = colorMap[statusColor] || "#000"; // Varsayılan olarak siyah

  const handleCardClick = () => {
    if (onUserClick && client.userInfo) {
      onUserClick(client.userInfo);
    }
  };

  return (
    <div
      className="rounded-[15px] md:rounded-[33px] p-2 bg-gradient-to-b from-[#FFFFFF] via-[#FFFFFF] to-[#E5D3DD] shadow-lg mb-3 md:w-[323px] md:h-[340px] w-[125px] h-[138px] cursor-pointer hover:shadow-xl transition-all duration-200 hover:scale-105 relative notranslate"
      onClick={handleCardClick}
      translate="no"
    >
      {/* Test Results Indicator */}
      {client.userInfo?.userResponses?.length > 0 && (
        <div className="absolute top-2 right-2 flex items-center bg-blue-500 text-white rounded-full px-2 py-1">
          <FileText size={12} className="mr-1" />
          <span className="text-xs font-medium">
            {client.userInfo.userResponses.length}
          </span>
        </div>
      )}

      <div className="text-center">
        <h3 className="md:text-[18px] text-[11px] font-poppins italic text-text">
         <span>{t("client")}</span><span>: </span><span>{client.name}</span>
        </h3>
        <p className="md:text-[14px] text-[7px] italic font-poppins text-black/70">
          <span>{client.sessionType}</span>
        </p>
        <hr
          style={{
            borderColor: borderColor,
            borderStyle: "solid",
          }}
          className="md:my-2 my-1 md:border-[2.25px] border-[1px] border-text"
        />
      </div>

      {/* Açıklama Alanı */}
      <div className="md:h-44 h-14 flex flex-col justify-center items-center">
        <p className="md:text-[15px] text-[6px] italic font-poppins text-[#000000] text-center mt-2">
          <span>{client.notes || "Pleace click the test results to see the notes."}</span>
        </p>
        {client.sessionLink && (
          <div className="mt-2 w-full px-2 text-center">
            <a
              href={client.sessionLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(event) => event.stopPropagation()}
              className="md:text-[13px] text-[6px] font-poppins text-primary underline break-all"
            >
              <span>{truncateLink(client.sessionLink)}</span>
            </a>
          </div>
        )}
      </div>

      {/* Alt Alan */}
      <div className="flex justify-between md:justify-around items-center md:px-2 px-1">
        <div>
          <p className="flex justify-center md:text-[15px] text-[7px] font-poppins text-text">
            <span>{time}</span>
          </p>
          <hr
            style={{
              borderColor: borderColor,
              borderStyle: "solid",
            }}
            className="md:w-[93px] w-[36px] md:border-[2.25px] border-[1px] md:-mx-4 -mx-2"
          />
        </div>
        <button
          className="md:w-[166px] w-[64px] md:h-[37px] h-[15px] mt-2 px-3 py-1 rounded-full md:text-[12px] text-[5px] font-poppins"
          style={{ backgroundColor: borderColor, color: textColor }}
        >
          <span>{status}</span>
        </button>
      </div>
    </div>
  );
};

export default ClientCard;
